import { Pipe, PipeTransform } from '@angular/core';
import { BuyerPersonaListItemDto } from '../../../dto';

@Pipe({
  name: 'buyerPersonasActionTooltip'
})
export class BuyerPersonasActionTooltipPipe implements PipeTransform {
  transform(row: BuyerPersonaListItemDto, isOpsAdminOrAdmin: boolean, action: string): string {
    if (!isOpsAdminOrAdmin) {
      return 'Ask your admin for assistance';
    }

    if (row?.isLocked) {
      return 'You cannot edit or delete a buying center that is in use.';
    }

    return action;
  }
}
